// A dead-simple global toast: one message at a time, shown by <Toast/> (mounted
// above the router so it survives navigation, e.g. being bounced out of a lobby).
type Listener = (msg: string | null) => void;

const listeners = new Set<Listener>();
let current: string | null = null;

export function showToast(msg: string): void {
  current = msg;
  listeners.forEach((l) => l(msg));
}

export function clearToast(): void {
  current = null;
  listeners.forEach((l) => l(null));
}

export function subscribeToast(fn: Listener): () => void {
  listeners.add(fn);
  fn(current);
  return () => {
    listeners.delete(fn);
  };
}
